import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ChooseRole() {
  const navigate = useNavigate();
  const { role } = useAuth();

  const goToBrowse = () => navigate("/listings");
  const goToAdd = () => navigate("/add");
  const goToAdmin = () => navigate("/admin/queue");

  return (
    <div className="auth-wrapper">
      <div className="auth-card role-card">
        <div className="auth-badge">Quick Actions</div>
        <h2>Choose Your Next Step</h2>
        <p className="auth-subtitle">Your role controls what you can do in the platform.</p>

        <div className="role-grid">
          <button className="role-option role-option-buyer" onClick={goToBrowse}>
            <div className="role-icon" aria-hidden="true">🏡</div>
            <h3>Browse Published Properties</h3>
            <p>Available for all authenticated roles.</p>
          </button>

          <button className="role-option role-option-seller" onClick={goToAdd}>
            <div className="role-icon" aria-hidden="true">📝</div>
            <h3>Submit Property</h3>
            <p>{role === "admin" ? "Publishes immediately." : "Goes to pending approval."}</p>
          </button>

          {role === "admin" ? (
            <button className="role-option" onClick={goToAdmin}>
              <div className="role-icon" aria-hidden="true">🛠️</div>
              <h3>Review Approval Queue</h3>
              <p>Approve, reject, edit, or delete pending submissions.</p>
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
